// extracted by mini-css-extract-plugin
export var addToCartButton = "_nc-b";
export var arrowButtonContainer = "_nc-9";
export var arrowButtonIcon = "_nc-a";
export var carouselArrowButton = "_nc-6";
export var carouselElementContainer = "_nc-1";
export var left = "_nc-7";
export var productDisplayCarouselContainer = "_nc-0";
export var productTileContainer = "_nc-2";
export var productTileImage = "_nc-4";
export var productTileImageContainer = "_nc-3";
export var productTileTitle = "_nc-5";
export var right = "_nc-8";
export var sliderOverflow = "_nc-c";